import React from 'react';
import Select from 'react-select';


const RetailerSelector = (props) => {

    const retailerOptions = props.retailers.map((retailer) => {
        return {
            id: retailer.gln,
            label: `${retailer.name} (${retailer.gln})`
        }
    });

    const onChange = (retailer) => {
        props.onChange(retailer.id);
    };

    const renderPleaseSelect = () => {
        if (props.showPleaseSelectOpt) {
            return (
                <option key='' value=''>Bitte wählen</option>
            )
        }
    };

    let selectedRetailer = retailerOptions.find(retailerOpt => retailerOpt.id === props.value);
    if(selectedRetailer === undefined) selectedRetailer = null;

    return (
        <div style={{width: '100%'}}>
            <Select name="form-field-name"
                    value={selectedRetailer}
                    onChange={onChange}
                    options={retailerOptions}
            />
        </div>
    );
};

RetailerSelector.defaultProps = {width: '200px', showPleaseSelectOpt: false, value: null};

export default RetailerSelector;



// WEBPACK FOOTER //
// ./src/admin/retailer/RetailerSelector.js